export const colors = {
    primaryColor: '#343539',
    secondaryColor: '#c8392b',
    textColor: '#fff',
    menuColor: '#3b3c40',
}